var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _vm.$route.path.indexOf("keyword") !== -1
        ? _c("pages-header", {
            ref: "pageHeader",
            attrs: {
              title: this.$route.params.id ? "关键字编辑" : "关键字添加",
              backUrl: "/operation/application/publicAccount/wxReply/keyword",
            },
          })
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "40px 50px" },
          },
        },
        [
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { gutter: 30 },
            },
            [
              _c(
                "el-col",
                _vm._b({ staticClass: "acea-row" }, "el-col", _vm.grid, false),
                [
                  _c("div", { staticClass: "left mb15 ml40" }, [
                    _c("img", {
                      staticClass: "top",
                      attrs: { src: require("@/assets/imgs/mobilehead.png") },
                    }),
                    _c("img", {
                      staticClass: "bottom",
                      attrs: { src: require("@/assets/imgs/mobilefoot.png") },
                    }),
                    _c("div", { staticClass: "centent" }, [
                      _c("div", { staticClass: "time-wrapper" }, [
                        _c("span", { staticClass: "time" }, [_vm._v("9:36")]),
                      ]),
                      _vm.formValidate.type !== "news"
                        ? _c(
                            "div",
                            { staticClass: "view-item text-box clearfix" },
                            [
                              _c("div", { staticClass: "avatar fl" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/imgs/head.gif"),
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "box-content fl" }, [
                                _vm.formValidate.type === "text"
                                  ? _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.formValidate.contents.content
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                _vm.formValidate.contents.mediaId
                                  ? _c(
                                      "div",
                                      { staticClass: "box-content_pic" },
                                      [
                                        _vm.formValidate.type === "image"
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.formValidate.contents
                                                  .srcUrl,
                                              },
                                            })
                                          : _c("i", {
                                              staticClass: "el-icon-service",
                                            }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.formValidate.type === "news"
                        ? _c("div", [
                            _c("div", { staticClass: "newsBox" }, [
                              _c("div", {
                                staticClass: "news_pic mb10",
                                style: {
                                  backgroundImage:
                                    "url(" +
                                    (_vm.formValidate.contents.articleData.cover
                                      ? _vm.formValidate.contents.articleData
                                          .cover
                                      : "") +
                                    ")",
                                  backgroundSize: "100% 100%",
                                },
                              }),
                              _c("span", { staticClass: "news_sp" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formValidate.contents.articleData.title
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-col",
                { attrs: { xl: 11, lg: 12, md: 14, sm: 22, xs: 22 } },
                [
                  _c(
                    "div",
                    { staticClass: "box-card ml50" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "formValidate",
                          staticClass: "mt20",
                          attrs: {
                            model: _vm.formValidate,
                            rules: _vm.ruleValidate,
                            "label-width": "100px",
                          },
                          nativeOn: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _vm.$route.path.indexOf("keyword") !== -1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "关键字", prop: "keywords" },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "from-ipt-width",
                                    attrs: { placeholder: "请填写关键字" },
                                    model: {
                                      value: _vm.formValidate.keywords,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValidate,
                                          "keywords",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formValidate.keywords",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$route.path.indexOf("keyword") !== -1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "规则状态：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "platform:wechat:public:keywords:reply:status",
                                          ],
                                          expression:
                                            "['platform:wechat:public:keywords:reply:status']",
                                        },
                                      ],
                                      model: {
                                        value: _vm.formValidate.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formValidate,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "formValidate.status",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: true } },
                                        [_vm._v("启用")]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: false } },
                                        [_vm._v("禁用")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: "消息类型：", prop: "type" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: { placeholder: "请选择规则状态" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.RuleFactor(
                                        _vm.formValidate.type
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.formValidate.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formValidate, "type", $$v)
                                    },
                                    expression: "formValidate.type",
                                  },
                                },
                                [
                                  _c(
                                    "el-option",
                                    {
                                      attrs: {
                                        label: "文本消息",
                                        value: "text",
                                      },
                                    },
                                    [_vm._v("文本消息")]
                                  ),
                                  _c(
                                    "el-option",
                                    {
                                      attrs: {
                                        label: "图片消息",
                                        value: "image",
                                      },
                                    },
                                    [_vm._v("图片消息")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.formValidate.type === "text"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "规则内容：",
                                    prop: "content",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "from-ipt-width",
                                    attrs: { placeholder: "请填写规则内容" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.formValidate.contents.content,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValidate.contents,
                                          "content",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "formValidate.contents.content",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formValidate.type === "news" &&
                          _vm.checkPermi([
                            "platform:wechat:public:keywords:reply:list",
                          ])
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "选取图文：" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: { click: _vm.changePic },
                                    },
                                    [_vm._v("选择图文消息")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formValidate.type === "image" ||
                          _vm.formValidate.type === "voice"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.formValidate.type === "image"
                                        ? "图片地址："
                                        : "语音地址：",
                                    prop: "mediaId",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    [
                                      _c("el-input", {
                                        staticClass: "mr10",
                                        staticStyle: { width: "75%" },
                                        attrs: {
                                          readonly: "readonly",
                                          placeholder: "default size",
                                        },
                                        model: {
                                          value:
                                            _vm.formValidate.contents.mediaId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formValidate.contents,
                                              "mediaId",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "formValidate.contents.mediaId",
                                        },
                                      }),
                                      _c(
                                        "el-upload",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [
                                                "platform:wechat:open:media:upload",
                                              ],
                                              expression:
                                                "['platform:wechat:open:media:upload']",
                                            },
                                          ],
                                          staticClass: "upload-demo mr10",
                                          attrs: {
                                            action: "",
                                            "http-request":
                                              _vm.handleUploadForm,
                                            headers: _vm.myHeaders,
                                            "show-file-list": false,
                                            multiple: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary",
                                              },
                                            },
                                            [_vm._v("点击上传")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.formValidate.type === "image",
                                          expression:
                                            "formValidate.type === 'image'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "文件最大5Mb，支持bmp/png/jpeg/jpg/gif格式"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.formValidate.type === "voice",
                                          expression:
                                            "formValidate.type === 'voice'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "文件最大5Mb，支持mp3/wma/wav/amr格式,播放长度不超过60s"
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "acea-row row-center" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "platform:wechat:public:keywords:reply:save",
                                  "platform:wechat:public:keywords:reply:update",
                                ],
                                expression:
                                  "[\n                  'platform:wechat:public:keywords:reply:save',\n                  'platform:wechat:public:keywords:reply:update',\n                ]",
                              },
                            ],
                            staticClass: "ml50",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submenus("formValidate")
                              },
                            },
                          },
                          [_vm._v("保存并发布 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }